import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AuthUserContext from "./context";
import { DataStoreContext } from "../DataStore/DataStoreContext";
import { Lock } from "@styled-icons/boxicons-regular/Lock";
import { Link } from "react-router-dom";
import styled from "styled-components";
import * as ROUTES from "../../constants/routes";
import { useNavigateCompat } from "../../helpFunctions/hooks";

const withAuthorization = (condition, showNoStatus) => Component => {
  const WithAuthorization = props => {
    const authContext = useContext(AuthUserContext);
    let stateContext = useContext(DataStoreContext);
    // Some routes may render outside DataStoreContext. Fall back to the auth user's
    // organization so authz checks can still resolve an org id.
    if (!stateContext) {
      stateContext = { selectedOrg: authContext?.authUser?.organization };
    }

    return authContext && condition(authContext.authUser, stateContext.state) ? (
      <Component {...props} authUser={authContext.authUser} />
    ) : (
      <>{!showNoStatus ? <AuthorizationFailed authContext={authContext} /> : null}</>
    );
  };

  return WithAuthorization;
};

const AuthorizationFailed = ({ authContext }) => {
  const location = useLocation();

  return (
    <>
      {/* Not authorized but signed in, render error */}
      {authContext && !authContext.loading && authContext.authUser && (
        <PermissionDenied>
          <Lock />
          <h2>You don't have permission to view this page.</h2>
          <h2 style={{ marginTop: "10px" }}>
            Return to <Link to={ROUTES.HOME}>Home page</Link>
          </h2>
        </PermissionDenied>
      )}
      {/* Not authorized because NOT signed in, REDIRECT */}
      {authContext && !authContext.loading && !authContext.authUser && <RedirectToSignIn location={location} />}
    </>
  );
};

const RedirectToSignIn = ({ location }) => {
  const navigate = useNavigateCompat();

  useEffect(() => {
    navigate(
      {
        pathname: ROUTES.SIGN_IN,
        search: location.search,
      },
      {
        replace: true,
        state: {
          nextUrl: location.pathname === ROUTES.SIGN_IN ? null : `${location.pathname}${location.search}`,
        },
      }
    );
  }, [location.pathname, location.search, navigate]);

  return null;
};

export default withAuthorization;

const PermissionDenied = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding: 1rem;
  margin-top: 6rem;
  // height: 100%;

  svg {
    width: 200px;
    height: 200px;
    color: var();
  }

  h2 {
    font-size: 1rem;
    text-align: center;
  }

  a {
    color: var(--key-color-2);
    text-decoration: underline;
  }
`;
